import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const TableRefBlock = observer(({ block }) => {
  // The store's table entry is the live count (kept in sync by corrections
  // and row removals); the block payload is the fallback before it exists.
  const table = copilotStore.tables.get(block.tableId);
  const totalCount = table ? table.totalCount : block.totalCount || 0;

  return (
    <div
      className="copilotTableCard"
      onClick={() => copilotStore.openTablePanel(block.tableId)}
    >
      <div className="copilotTableCard__icon">
        <i className="material-icons-outlined">grid_on</i>
      </div>
      <div className="copilotTableCard__meta">
        <div className="copilotTableCard__title">{block.title}</div>
        <div className="copilotTableCard__count">
          {totalCount.toLocaleString()} records · live table
        </div>
      </div>
      <div className="copilotTableCard__open">
        <span>View</span>
        <i className="material-icons-outlined">chevron_right</i>
      </div>
    </div>
  );
});

export default TableRefBlock;
